export const environment = {
  production: true,
  api: 'https://api-netta.azurewebsites.net/',
  apiGoogle: 'https://maps.googleapis.com/maps/api/geocode/json?key=AIzaSyBxyqx1ovc98MV7imdwemTz421H_VsCBrM',
  conektaKey: 'key_ZPbKg6WTKfsnpwM1msgb6aQ',
  conektaLocale: 'es',
  conektaScript: 'https://cdn.conekta.io/js/latest/conekta.js',

  firebaseConfig: {
    apiKey: "AIzaSyB_lY_6FD4I0oA6Kriex4nn0Yo5xe5eHLI",
    authDomain: "netta-2fb64.firebaseapp.com",
    projectId: "netta-2fb64",
    storageBucket: "netta-2fb64.appspot.com",
    messagingSenderId: "910246763135",
    appId: "1:910246763135:web:f07ffe79230f8ec30ebd4a",
    measurementId: "G-YMDECZVLRW",
    vapidKey: "BN53r-YaH5d4LSFfeTJylx_EbxLc5wVQGnS3rsFSZHTxj2WDWVitGLuLK3q3vUwYZmw1LSFrF5FzmTwE7saFVUQ"
  },
  vapidKeyFirebase: "BF8d8RnT-cvyn_vKDPmd3gN7XDEuk8cUYKhhqOyX6UidIAceV0fF_ZGm9U-L1JK8-HZS3Pv8wx7Ve1mU0e25t40",

  ws: 'https://web-socket.azurewebsites.net',

  //rappi
  rappi_client_id: 'cc19a644-3ea1-4174-ac00-f36e3c6dfee1',
  rappi_client_secret: 'blDSJ+yrfRb7xI3txJ0dsCfmjH1y2U0wLxIBDeTB9Q4=',
  rappi_host: 'https://services.rappi.com/',
  rappi_currency: 'MXN',
  rappi_script: 'https://services.rappi.com/rms/merchant-services/sdk/v2/rms.js',
  
  whatsapp: '55 39 311 143',
  landing: 'https://netta.mx/',

  api_key_weetrust: '5de5800886972b5b862c3c977dc1f1bb8c3c1818',
  script_weetrust: 'https://widget.weetrust.mx',
  stripe_key: 'pk_live_51NBUF6FNlm16gKD2CeY34bCc2D8GmO3P8OfdiDmcUrryvgd6vivg6j6YjQB9rzmF3mPq8iaXhmcc8Cm8UtdzuaVI00J4IPGTJp'
};
